import $ from 'jquery';
import common from './common';
import scroll from './scroll';
import {gsap} from "gsap";

const transitions = {
    elClicked: null,
    play: false,
    next: null,
    anchorTarget: null,
    speedShow: 1,
    delayShow: 0.6,

    basicTransition: {
        leave({current, next}) {
            transitions.showNamespace(next);
            const header = document.getElementById('bc-header');
            if (header) header.style.visibility = 'hidden';
            common.goTOP();
            current.container.style.opacity = '0';
            if (scroll.locomotiveScroll) {
                scroll.destroy();
            }
            return Promise.resolve();
        },

        enter({next}) {
            next.container.style.visibility = 'visible';
            common.init();
            scroll.locomotive();
            const header = document.getElementById('bc-header');
            if (header) header.style.visibility = '';
            if (transitions.anchorTarget) {
                setTimeout(() => {
                    const target = document.querySelector('#' + transitions.anchorTarget);
                    if (target && scroll.locomotiveScroll) {
                        scroll.locomotiveScroll.scrollTo(target, {duration: 0, disableLerp: true});
                    }
                    transitions.anchorTarget = null;
                }, 400);
            }
        }
    },

    showNamespace(next) {
        const namespace = next.namespace;
        $(".nav > li[data-m!="+namespace+"]").removeClass("_activ");
        $(".nav > li[data-m="+namespace+"]").addClass("_activ");
        $("._nav_mobile > ._item[data-m=" + namespace + "]").addClass("_activ");
        $("._nav_mobile > ._item[data-m!=" + namespace + "]").removeClass("_activ");
    }
};

export default transitions;
